export default "__VITE_ASSET__CTEsVLKm__"